import { IObservable, Subject } from '~/rage/utils';
import { IContact } from '~/shared';
import { BackendService } from '../BackendService';
import { IContactsService } from './contactsServiceTypes';

export class ContactsService implements IContactsService {
	private readonly contacts = new Subject<IContact[]>([]);

	constructor(private readonly backend: BackendService) {
		this.backend.addEventHandler('contacts:update', (list: IContact[]) => {
			this.contacts.next(list);
		});
	}

	getContacts(): IObservable<IContact[]> {
		return this.contacts;
	}

	addContact(phoneNumber: string, name: string): Promise<void> {
		return this.backend.invoke('contacts:add', { phoneNumber, name });
	}

	removeContact(phoneNumber: string): Promise<void> {
		return this.backend.invoke('contacts:remove', { phoneNumber });
	}

	toggleFavorite(phoneNumber: string): Promise<void> {
		return this.backend.invoke('contacts:toggleFavorite', { phoneNumber });
	}
}
